import { render, staticRenderFns } from "./pages.page.vue?vue&type=template&id=05f0af5e&scoped=true&"
import script from "./pages.page.vue?vue&type=script&lang=js&"
export * from "./pages.page.vue?vue&type=script&lang=js&"
import style0 from "./pages.page.vue?vue&type=style&index=0&id=05f0af5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0af5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
